import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthService} from '../../../services/auth.service';
import {Router} from '@angular/router';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation,
    fadeInUpBigOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {UserService} from '../../../services/user.service';
import {Subscription} from 'rxjs';
import {EventsService} from '../../../services/events.service';
import {ProgressModel} from '../../../services/models/progress.model';
import {ProgressService} from '../../../services/progress.service';
import {environment} from '../../../../environments/environment';
import {AnalyticsService} from '../../../services/analytics.service';
import {LeaderboardService} from '../service/leaderboard.service';
import {LeaderboardModel} from '../models/leaderboard.model';

@Component({
    selector: 'app-leaderboard-page',
    templateUrl: 'leaderboard.page.html',
    styleUrls: ['leaderboard.page.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
        fadeInUpBigOnEnterAnimation({anchor: 'enterUp', duration: 300}),
    ],
})
export class LeaderboardPage implements OnInit, OnDestroy {

    subscriptions: Subscription[] = [];

    environment = null;
    menuVisible = true;

    leaderboardData: LeaderboardModel[] = null;
    leaderboardPromise: Promise<LeaderboardModel[]> = null;
    leaderboardValid = false;
    userType = null;

    progress: ProgressModel = null;
    progressPromise: Promise<ProgressModel> = null;
    progressValid = false;
    platform = 'website';

    constructor(
        private event: EventsService,
        public authService: AuthService,
        private leaderboardService: LeaderboardService,
        public userService: UserService,
        private analytics: AnalyticsService,
    ) {
        this.environment = environment;
        this.subscriptions.push(
            this.event.subscribe('login', () => {
                this.leaderboardValid = false;
                this.progressValid = false;
            })
        );
        this.subscriptions.push(
            this.event.subscribe('logout', () => this.leaderboardValid = false)
        );
    }

    ngOnInit(): void {
        this.platform = environment.platform;
    }


    ionViewWillEnter() {
        if (this.leaderboardData === null || !this.leaderboardValid) {
            if (this.userService.userInfo?.client_id === 134) {
                this.leaderboardPromise = this.leaderboardService.getLeaderboardWorld([363], 'world');
            } else {
                this.leaderboardPromise = this.leaderboardService.getLeaderboard();
            }
        }
    }

    ionViewDidEnter() {
        this.analytics.trackView('Global Leaderboard');

        if (this.leaderboardData === null || !this.leaderboardValid) {
            this.leaderboardPromise.then(data => {
                this.leaderboardData = data;
                this.leaderboardValid = true;
            });
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(i => i.unsubscribe());
    }
}
